import { makeStyles, shorthands } from '@fluentui/react-components';

const commonStyles = {
  boxShadow: '0px 1.47522px 4.42567px rgba(0, 0, 0, 0.2), inset 0.295044px -0.295044px 0.590089px rgba(0, 0, 0, 0.2), inset -0.590089px 0.590089px 1.47522px rgba(255, 255, 255, 0.3)',
  ...shorthands.borderRadius('2px'),
};

export const useFolderIconStyle = makeStyles({
  folderIconContainer: {
    position: 'relative',
    height: '52px',
    width: '68px',

    '& .folder-tag': {
      width: '50%',
      height: '28.36%',
      ...commonStyles,
    },

    '& .folder-content': {
      width: '100%',
      height: '85.84%',
      ...commonStyles,

      position: 'absolute',
      left: 0,
      bottom: 0,
      ...shorthands.overflow('hidden'),
    },
  },
  folderTag: {
    backgroundColor: '#1F65F1',
  },
  emptyFolderTag: {
    backgroundColor: '#A0A0A0',
  },
  folderContent: {
    backgroundColor: '#1F65F1',
  },
  emptyFolderContent: {
    backgroundColor: '#C4C4C4',
  },
});
